export enum TypeThatClientsQueueSystemDependsOn {
  ServicesCategories = 1,
  Employees = 2,
  Days = 3
}
